import { render } from "./ProductActivity.vue?vue&type=template&id=5d84fe84"
import script from "./ProductActivity.vue?vue&type=script&lang=js"
export * from "./ProductActivity.vue?vue&type=script&lang=js"

import "./ProductActivity.vue?vue&type=style&index=0&id=5d84fe84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__